import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { isLogin } from '../../utils/auth';
import { useModal } from '../../context/ModalContext';

const protectedArr = [
  '/map',
  '/myPattern',
  '/myPetternList',
  '/AiRecommendation',
  '/quant',
  '/mypage',
  '/auction',
  '/pauction',
];

function RouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const isLoggedIn = isLogin();
  const { modalDispatch } = useModal();

  useEffect(() => {
    const path = location.pathname;
    const isProtected = protectedArr.some((protectedPath) => {
      return path.startsWith(protectedPath.replace(/:\w+/, ''));
    });

    if (!isLoggedIn && isProtected) {
      modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
      navigate('/');
      return;
    }
  }, [isLoggedIn, location.pathname]);

  return null;
}

export default RouteGuard;
